// CommonRangePicker.js
import React, { useState } from "react";
import { DatePicker } from "antd";
import moment from "moment";
import { shallowEqual, useSelector } from "react-redux";
import { getDateTimeInZone, getSettingKey } from "./../../modules/Common/utils";
import RangePickerComponent from "./RangePicker";

const CommonRangePicker = ({
  type,
  value = [],
  onChange,
  disabled = false,
  format = "MM-DD-YYYY",
  allowClear = false,
  showToday = false,
  onTodaySelectInTypeDatePicker = () => {},
  additionalClassName = "",
  // date-picker only; opt-in so existing callers keep antd's default display format / onChange value
  pickerFormat,
  placeholder,
}) => {
  const [openDatePicker, setOpenDatePicker] = useState(false);

  const { currentState } = useSelector((state) => ({ currentState: state.basicSettings }), shallowEqual);
  const { entity } = currentState;
  const timezone = getSettingKey(entity, "Basic", "timezone");

  if (type == "range-picker") {
    return <RangePickerComponent format={format} allowClear={allowClear} value={value} onChange={onChange} additionalClassName={additionalClassName} />;
  } else if (type == "date-picker") {
    const todayMoment = moment(getDateTimeInZone(timezone)?.split("T")[0]);

    return (
      <DatePicker
        onChange={(date, value) => {
          onChange(date, value);
          setOpenDatePicker(false);
        }}
        className={`p-2 pb-3 px-5 w-100 text-secondary rounded border-secondary ${additionalClassName}`}
        showToday={showToday}
        {...(pickerFormat ? { format: pickerFormat } : {})}
        {...(placeholder ? { placeholder } : {})}
        open={openDatePicker}
        value={value}
        disabled={disabled}
        onFocus={() => setOpenDatePicker(true)}
        onClick={() => setOpenDatePicker(true)}
        onBlur={() => setOpenDatePicker(false)}
        // defaultPickerValue={todayMoment}
        renderExtraFooter={() => (
          <div
            style={{ textAlign: "center", cursor: "pointer", color: "#1890ff" }}
            onClick={() => {
              setOpenDatePicker(false);
              onTodaySelectInTypeDatePicker(todayMoment);
            }}
          >
            Today
          </div>
        )}
      />
    );
  }
};

export default CommonRangePicker;
